import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.revenue_report_local',
};
